/**
 * Utilities for working with `tsconfig.json` files.  This module
 * primarily exports types equivalent to the types of values encountered
 * in `tsconfig.json` files that are not exported by the `typescript` package.
 *
 * @module @sorrell/utilities/tsconfig
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./TsConfig.Types.ts";
